// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dSCV","location":"Header_location__MZ8fX"};